import React from "react";

export default ({ width = 16, height = 15, fill = "#18A0FB", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00132 0.666992C8.25507 0.666992 8.48681 0.81104 8.59913 1.03858L10.5042 4.89797L14.7644 5.52067C15.0154 5.55736 15.2239 5.73337 15.3022 5.9747C15.3804 6.21604 15.3149 6.48088 15.1331 6.6579L12.051 9.6599L12.7784 13.901C12.8213 14.1511 12.7185 14.4039 12.5131 14.553C12.3078 14.7022 12.0356 14.7218 11.811 14.6037L8.00132 12.6002L4.19162 14.6037C3.96701 14.7218 3.69482 14.7022 3.4895 14.553C3.28418 14.4039 3.18135 14.1511 3.22425 13.901L3.95164 9.6599L0.8695 6.6579C0.687754 6.48088 0.622239 6.21604 0.700491 5.9747C0.778743 5.73337 0.987196 5.55736 1.23824 5.52067L5.49848 4.89797L7.40352 1.03858C7.51583 0.81104 7.74758 0.666992 8.00132 0.666992ZM8.00132 2.83983L6.53913 5.80208C6.4421 5.99864 6.25464 6.13495 6.03774 6.16665L2.76693 6.64473L5.13314 8.94942C5.29039 9.10258 5.36217 9.32334 5.32506 9.53969L4.76678 12.7948L7.69102 11.2569C7.88528 11.1548 8.11737 11.1548 8.31162 11.2569L11.2359 12.7948L10.6776 9.53969C10.6405 9.32334 10.7123 9.10258 10.8695 8.94942L13.2357 6.64473L9.9649 6.16665C9.748 6.13495 9.56054 5.99864 9.46352 5.80208L8.00132 2.83983Z"
        fill={fill}
      />
    </svg>
  );
};
